<button class="btn-icon-svg " (click)="onClose()">
  <span class="svg-icon svg-icon-dark">
    <svg-icon src="/assets/icons/svg/x.svg"></svg-icon>
  </span>
</button>

<div id="some-id"></div>
